export default String.raw`
.blog-container {
    width: 100%;
    padding: 0 25px;

    &__title {
        h1 {
            @include h3-headline;
        }
        
        margin-bottom: 24px;
    }

    &__list {
        grid-template-columns: 100%;
        justify-content: center;
    }
}
`